import { formatFilterDuration } from 'src/utils/helpers/formatFilterDuration';

const DATE_DURATION_OPS = ['lastDate', 'gtDate', 'ltDate'];

const formatEnumText = (value, getLabel) => {
	const values = Array.isArray(value) ? value : [value];
	const labels = values
		.filter((item) => item !== '' && item != null)
		.map((item) => getLabel?.(item) ?? String(item));

	if (!labels.length) return String(value ?? '');
	if (labels.length === 1) return labels[0];

	return `${labels.length} значения`;
};

export function mapSelectedFilters(filters, columnsByCode, getEnumLabel) {
	return Object.entries(filters).reduce((acc, [code, filter]) => {
		const column = columnsByCode.get(code);
		const [op, value] = Object.entries(filter)[0] ?? [];
		let text = column?.meta?.getFilterLabel?.(value) ?? String(value);

		if (op === 'isNull' || op === 'isNotNull') {
			text = value === true || String(value) === 'true' ? 'Пусто' : 'Не пусто';
		} else if (getEnumLabel?.(code)) {
			text = formatEnumText(value, getEnumLabel(code));
		} else if (DATE_DURATION_OPS.includes(op)) {
			text = formatFilterDuration(value, op);
		} else if (op === 'rangeDate' && typeof value === 'string') {
			const [from, to] = value.split('~');
			text = `с ${from} по ${to}`;
		} else if (op === 'range' && typeof value === 'string') {
			const [from, to] = value.split('~');
			text = `от ${from} до ${to}`;
		} else if (value === true) {
			text = 'Да';
		} else if (value === false) {
			text = 'Нет';
		}

		acc[code] = { text, value };

		return acc;
	}, {});
}

export function indexColumnsByCode(columns) {
	const map = new Map();

	for (const col of columns) {
		if (col.filter?.code) map.set(col.filter.code, col);

		map.set(col.id, col);
	}

	return map;
}
